<template>
    <div class="tip-wrap">
        <div class="success-tip">
            <i class="city ct-zhengque"></i>
        </div>
        <h2 class="title" :style="infoStyle">{{ info }}</h2>
    </div>
</template>

<script>
export default {
    name: "successTip",
    props: {
        infoStyle: {
            type: Object,
            default: () => {},
            comment: "info style",
        },
        info: {
            type: String,
            comment: "info style",
        },
    },
};
</script>

<style lang="scss" scoped>
.success-tip {
    width: 150px;
    height: 150px;
    margin: 70px auto 0;
    border-radius: 50%;
    text-align: center;
    line-height: 150px;
    background: -moz-linear-gradient(
        to right bottom,
        var(--bg-linear) 0%,
        var(--main-color) 100%
    );
    background: -webkit-linear-gradient(
        to right bottom,
        var(--bg-linear) 0%,
        var(--main-color) 100%
    );
    background: -o-linear-gradient(
        to right bottom,
        var(--bg-linear) 0%,
        var(--main-color) 100%
    );
    background: -ms-linear-gradient(
        to right bottom,
        var(--bg-linear) 0%,
        var(--main-color) 100%
    );
    background: linear-gradient(
        to right bottom,
        var(--bg-linear) 0%,
        var(--main-color) 100%
    );

    i {
        font-size: 128px;
        color: #fff;
    }
}
.title {
    width: 50%;
    margin: 15px auto;
    line-height: 40px;
    font-weight: bold;
    font-size: 18px;
    text-align: center;
    color: #424242;
}
</style>